export default "__VITE_PUBLIC_ASSET__30866d7a__"